import { BaseFormula } from "../BaseFormula";
import { CalculationResult } from "../CalculationResult";
import { ChangeType } from "../ChangeType";
import { CostData } from "../CostData";

export class Formula_InterquartileRange extends BaseFormula
{
    evaluate(data: CostData[], value: CostData, change: ChangeType, parameters: { multiplier: number }, show_new_cost: boolean): CalculationResult
    {
        let err = this.checkLength(data, 4, show_new_cost);
        if (err)
            return err;

        let sorted = [...data].sort((a, b) => a.amount - b.amount);
        let q1 = this.calculatePercentile(sorted, 25);
        let q3 = this.calculatePercentile(sorted, 75);
        let iqr = q3 - q1;

        if (iqr === 0)
            return {
                value: null,
                reason: `IQR is zero.`,
                values: { q1, q3, iqr }
            };

        let lower_bound = q1 - parameters.multiplier * iqr;
        let upper_bound = q3 + parameters.multiplier * iqr;
        let difference = 0;
        if (value.amount < lower_bound)
            difference = value.amount - lower_bound;
        if (value.amount > upper_bound)
            difference = value.amount - upper_bound;

        err = this.checkChnage(change, difference, { q1, q3, iqr, lower_bound, upper_bound, difference });
        if (err)
            return err;

        return {
            value: value.amount < lower_bound || value.amount > upper_bound,
            values: { q1, q3, iqr, lower_bound, upper_bound, difference }
        };
    }

    private calculatePercentile(sortedData: CostData[], percentile: number): number
    {
        const index = (percentile / 100) * (sortedData.length - 1);
        const lower = Math.floor(index);
        const upper = Math.ceil(index);
        const weight = index - lower;

        if (upper >= sortedData.length) return sortedData[lower].amount;
        return sortedData[lower].amount * (1 - weight) + sortedData[upper].amount * weight;
    }
} 